/* eslint-disable @typescript-eslint/no-explicit-any */

import * as MessageService from '~/services/message';

import { decreaseLoading, increaseLoading } from './loading';
import GroupApi from '@portal/repositories/group';
import {
  CREATE_GROUP,
  EDIT_GROUP,
  GET_GROUP_FOR_ID,
  SET_LIST_ALL_GROUP,
} from './actionTypes';
import { TransactionRule } from '../models/reducers';

export const createGroup =
  (name: string, roles: string[] | null, transactionRule?: TransactionRule) =>
  async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await GroupApi.createGroup(name, roles, transactionRule);
      MessageService.success('PAGES.PROFILE_MANAGER.CREATED_GROUP');
      dispatch({
        type: CREATE_GROUP,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const listAllGroups =
  (limit = 10, offset: number, name: string) =>
  async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      const payload = await GroupApi.listGroup(limit, offset, name);
      dispatch({
        type: SET_LIST_ALL_GROUP,
        payload,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const editGroup =
  (
    name: string,
    roles: string[] | null,
    id: string,
    transactionRule?: TransactionRule
  ) =>
  async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await GroupApi.editGroup(name, roles, id, transactionRule);
      MessageService.success('PAGES.PROFILE_MANAGER.EDIT_GROUP');
      dispatch({
        type: EDIT_GROUP,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getGroupForId = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await GroupApi.getGroup(id);
    dispatch({
      type: GET_GROUP_FOR_ID,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};
